import { Radio as AntdRadio, RadioProps } from 'antd';
import { FC } from 'react';

const Radio: FC<RadioProps> = (props) => {
  return <AntdRadio {...props} />;
};

export default Radio;
